<div class="error-404-sec">
    <img src="assets/img/error-404-img.webp" alt="error-404-img">
    <a href="/" class="site-btn">Return to Home</a>
</div>

<app-footer></app-footer>
